import axios from "axios";

const rawBase = (
  process.env.REACT_APP_API_BASE_URL ||
  process.env.REACT_APP_BACKEND_URL ||
  process.env.REACT_APP_BACKEND ||
  "http://localhost:8000/api/v1"
)
  .trim()
  .replace(/([^:]\/)\/+/g, "$1")
  .replace(/\/+$/, "");

const baseUrl = rawBase.includes("/api/v1") ? rawBase : `${rawBase}/api/v1`;

const api = axios.create({
  baseURL: baseUrl,
  timeout: 30000,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  try {
    const stored = localStorage.getItem("user");
    if (stored) {
      const user = JSON.parse(stored);
      if (user?.token) {
        config.headers.Authorization = `Bearer ${user.token}`;
      }
    }
  } catch {
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const getRequest = (url, config) => api.get(url, config);
export const postRequest = (url, data, config) => api.post(url, data, config);
export const patchRequest = (url, data, config) => api.patch(url, data, config);
export const deleteRequest = (url, config) => api.delete(url, config);

export default api;
